var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-checkbox-input',{staticClass:"custom-control custom-checkbox stores-list-checkbox",attrs:{"name":`${_vm.checkboxName}`},on:{"change":_vm.checkboxClick},model:{value:(_vm.localSelected),callback:function ($$v) {_vm.localSelected=$$v},expression:"localSelected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }